import { EFinancingProgram } from '@if/core/types'
import NotFound from '@src/components/NotFound'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import type { IfUser } from '@if/mui'
import { Merchant } from '@src/types/Merchant'
import { useMemo } from 'react'
import { usePaymentPlanList } from '../ViewCreditApplicationPage/worksheet-hooks'
import ProductsWorksheetPage from './CreateProductsWorksheetPage/ProductsWorksheet'
import IfXpressWorksheet from './IfXpress/IfXpressWorksheet'
import MechanicalWarrantyWorksheetPage from './MechanicalWarranty/MechanicalWarrantyWorksheetPage'
import PersonalLoanWorksheet from './PersonalLoanWorksheet'

interface Props {
  creditApplication: CreditApplication
  user: IfUser
  merchant: Merchant
  merchantsListFromParentId: Merchant[]
}

const CreateWorksheetPage = ({ creditApplication, user, merchant, merchantsListFromParentId }: Props) => {
  const merchantPaymentPlans = useMemo(() => {
    return merchant?.paymentPlans ?? []
  }, [merchant?.paymentPlans])
  const merchantPayments = usePaymentPlanList(creditApplication, merchant, merchantPaymentPlans)

  if (creditApplication && merchant)
    switch (creditApplication.financingProgramId) {
      case EFinancingProgram.Personal:
        return (
          <PersonalLoanWorksheet
            merchant={merchant}
            creditApplication={creditApplication}
            user={user}
            merchantsListFromParentId={merchantsListFromParentId}
            merchantPayments={merchantPayments}
          />
        )
      case EFinancingProgram.IfXpress:
        return (
          <IfXpressWorksheet
            merchant={merchant}
            creditApplication={creditApplication}
            merchantPayments={merchantPayments}
          />
        )
      case EFinancingProgram.Products:
        return (
          <ProductsWorksheetPage
            merchant={merchant}
            creditApplication={creditApplication}
            merchantPayments={merchantPayments}
          />
        )
      case EFinancingProgram.MechanicalWarranty:
        return <MechanicalWarrantyWorksheetPage creditApplication={creditApplication} />
      default:
        return <NotFound />
    }

  return <NotFound />
}

export default CreateWorksheetPage
